{
  "transferLost": "Передача потеряна при перезагрузке экрана",
  "transferFailed": "Передача не удалась",
  "newFolder": "Новая папка",
  "newFolderName": "Имя нового каталога",
  "newName": "Новое имя",
  "oneItem": "«{{name}}»",
  "manyItems_one": "{{count}} объект",
  "manyItems_few": "{{count}} объекта",
  "manyItems_many": "{{count}} объектов",
  "manyItems_other": "{{count}} объекта",
  "deleteConfirm": "Удалить {{what}} на машине {{node}}? Отменить это будет нельзя.",
  "download": "Забрать к себе",
  "transferring": "передаётся",
  "sendToMachine": "Отправить на машину",
  "sendSelected": "Отправить выбранное на машину",
  "noWritePermission": "Нет права записи на машину",
  "noFolderPicked": "каталог не выбран",
  "pickedFiles": "выбранные файлы",
  "folderEmpty": "Каталог пуст.",
  "openLocalFolder": "Откройте каталог на своей машине — в него будут попадать забранные файлы.",
  "noDirectoryPicker": "Этот браузер не показывает каталоги. Выберите файлы, чтобы отправить их на машину; забранные файлы он сохранит сам.",
  "refreshList": "Обновить список",
  "folderFailed": "Каталог не открылся",
  "readingFolder": "Читаем каталог…",
  "machineDrives": "диски машины",
  "toMachine": "На машину",
  "fromMachine": "С машины",
  "abortAria": "Прервать передачу {{name}}",
  "retryAria": "Повторить передачу {{name}}",
  "noStream": "Браузер не отдал содержимое файла потоком",
  "partialTransfer": "Файл передан не целиком: {{received}} из {{total}} байт.",
  "queued": "в очереди",
  "cancelled": "отменено",
  "failed": "не удалось",
  "done": "готово · {{size}}",
  "rate": "{{size}}/с",
  "downloadSelected": "Забрать выбранное с машины",
  "local": "Локально",
  "remote": "Удалённо",
  "size": "Размер",
  "modified": "Изменён",
  "title": "Файлы · {{node}}",
  "name": "Имя",
  "tightVncAvailable": "расширение TightVNC доступно",
  "secondConnection": "второе RFB-соединение · закроется через 5 мин бездействия",
  "noDirectoryAccess": "Этот браузер не даёт странице доступ к каталогам: забранные файлы он сохранит сам, и большой файл при этом целиком окажется в памяти вкладки. Для гигабайтных файлов используйте Chrome или Edge.",
  "openDirectory": "Открыть каталог",
  "pickFiles": "Выбрать файлы",
  "queue": {
    "title": "Очередь передач · {{count}}",
    "clearFinished": "Убрать законченные",
    "limit": "не больше {{limit}} одновременно · пути с «..» отклоняются",
    "empty": "Перетащите файлы на панель машины или выберите их и нажмите стрелку."
  }
}
